module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.4f0112ad.png";